'use client';
import { Button } from "flowbite-react";
import { useAtom } from "jotai";
import { PiFilmSlateBold, PiWaveSawtooth } from "react-icons/pi";

import { Switch } from '@headlessui/react';
import { animationTypeAtom } from "app/components/atoms/animationFormAtoms";


export default function MotionTypeSelector() {
    const [animationType, setAnimationType] = useAtom(animationTypeAtom);

    const handleClick = (type: 'classic' | 'audio-reactive') => {
        setAnimationType(type);
    };

    return (
        <div className="h-14 items-center justify-between inline-flex text-sm leading-none text-neutral-400 select-none outline-1 outline">
            <Button
                className={`focus:outline-0 bg-transparent border-0 dark:border-white border-black dark:text-white text-black border-l-none rounded-none group inline-flex items-center px-1 py-1 transition-colors duration-150 ease-in focus:outline-none`}
                id="grid"
                onClick={() => handleClick('classic')}
            >
                <PiFilmSlateBold className="mr-2 text-xl" />
                <span className={`${animationType === 'audio-reactive' ? 'text-neutral-400 dark:text-neutral-400' : ''}`} >Classic</span>
            </Button>
            <Switch
                checked={animationType === 'audio-reactive'}
                name="duration30s"
                onClick={() => { handleClick(animationType === 'classic' ? 'audio-reactive' : 'classic') }}
                className="ml-0 mr-0 relative inline-flex h-2 w-8 items-center self-center rounded-none ui-checked:bg-blue-400 ui-not-checked:bg-neutral-400 ui-not-checked:dark:bg-neutral-600">
                <span className="inline-block h-5 w-5 transform rounded-sm bg-neutral-500 dark:bg-neutral-400 transition ui-checked:translate-x-6 ui-not-checked:-translate-x-1" />
            </Switch>
            <Button
                className={`focus:outline-0 bg-transparent border-0 dark:border-white border-black dark:text-white text-black rounded-none group inline-flex items-center px-1 py-1 transition-colors duration-150 ease-in focus:outline-none`}
                id="list"
                onClick={() => handleClick('audio-reactive')}
            >
                <PiWaveSawtooth className="mr-2 text-xl" />
                <span className={`${animationType === 'classic' ? 'text-neutral-400' : ''}`} >Audio Sync</span>
            </Button>
        </div>
    );
}